var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMelanoma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3809 18.1681L14.3009 18.5981C14.2309 18.9781 13.9109 19.2681 13.5309 19.2981L13.3109 19.3181C13.1509 19.3281 13.0009 19.3881 12.8809 19.4781L12.3509 19.8581C12.0609 20.0681 11.6709 20.0681 11.3709 19.8581C11.3709 19.8581 10.9109 19.5381 10.7109 19.3581C10.6909 19.3381 10.6209 19.3481 10.6009 19.3281L9.90086 18.9481C9.59086 18.7781 9.42085 18.4381 9.46085 18.0981L9.80085 17.2481L9.64086 16.4381C9.67086 16.0981 9.79086 15.6281 10.1209 15.5181H10.8009C10.8809 15.4881 10.9609 15.4481 11.0309 15.3981L11.9409 14.7481C12.2409 14.5381 12.6409 14.5381 12.9409 14.7581L13.2109 14.9581C13.3009 15.0281 13.4109 15.0781 13.5309 15.1081L13.8609 15.1881C14.3609 15.3081 14.6509 15.8381 14.4609 16.3281C14.3409 16.6381 14.4109 16.9881 14.6409 17.2181L14.6609 17.7681L14.3909 18.1581L14.3809 18.1681Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.1084L4.56 17.0884",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0098 15.6885C17.0098 15.6885 17.0998 15.6885 19.3698 16.9885C19.6398 17.1385 21.2598 15.9785 21.2598 15.9785",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35981 12.2672L6.02981 11.9872C5.72981 11.7372 5.63981 11.3172 5.80981 10.9672L5.9098 10.7672C5.9798 10.6272 6.0098 10.4672 5.9898 10.3172L5.9298 9.67719C5.8898 9.31719 6.0898 8.97719 6.4098 8.82719C6.4098 8.82719 6.91981 8.59719 7.16981 8.50719C7.19981 8.50719 7.21981 8.43719 7.24981 8.41719L7.9298 8.00719C8.2298 7.82719 8.60981 7.84719 8.88981 8.05719L9.44981 8.76719L10.2298 9.02719C10.5098 9.22719 10.8598 9.56719 10.7898 9.89719L10.4598 10.4872C10.4398 10.5672 10.4398 10.6572 10.4498 10.7372L10.5498 11.8572C10.5798 12.2272 10.3798 12.5672 10.0398 12.7172L9.72981 12.8472C9.61981 12.8972 9.52981 12.9572 9.44981 13.0472L9.21981 13.2972C8.86981 13.6772 8.2598 13.6572 7.9398 13.2472C7.7298 12.9872 7.39981 12.8772 7.07981 12.9572L6.58981 12.7072L6.3798 12.2772L6.35981 12.2672Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8292 3.4375L12.1992 4.3075",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18956 15.7871C7.18956 15.7871 7.14956 15.8671 4.87956 17.1771C4.60956 17.3271 4.80957 19.3271 4.80957 19.3271",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4797 8.26826L15.8897 8.11826C16.2497 7.98826 16.6597 8.11826 16.8797 8.43826L17.0097 8.62826C17.0997 8.75826 17.2197 8.85826 17.3597 8.92826L17.9497 9.19826C18.2797 9.34826 18.4797 9.67826 18.4497 10.0383C18.4497 10.0383 18.3997 10.5983 18.3497 10.8583C18.3497 10.8883 18.3797 10.9383 18.3797 10.9683L18.3997 11.7583C18.3997 12.1083 18.1997 12.4283 17.8797 12.5683L16.9797 12.6983L16.3597 13.2483C16.0497 13.3883 15.5797 13.5183 15.3297 13.2983L14.9897 12.7183C14.9297 12.6583 14.8597 12.6183 14.7797 12.5783L13.7597 12.1083C13.4297 11.9583 13.2297 11.5983 13.2697 11.2383L13.3097 10.8983C13.3197 10.7783 13.3097 10.6683 13.2797 10.5483L13.1797 10.2183C13.0297 9.72826 13.3497 9.20826 13.8597 9.12826C14.1897 9.07826 14.4497 8.84826 14.5497 8.52826L15.0097 8.23826L15.4897 8.27826L15.4797 8.26826Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3906 19.1576L19.4506 17.3076",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0204 7.23796C12.0204 7.23796 11.9704 7.15796 11.9704 4.54796C11.9704 1.93796 10.1504 3.41796 10.1504 3.41796",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelanoma);
export default __webpack_public_path__ + "static/media/Melanoma.618c03250afe4721e00de0012b234e92.svg";
export { ForwardRef as ReactComponent };